export default __webpack_public_path__ + "static/media/gopherpng.a6170f4f.png";